import { Link } from 'react-router-dom';

export default function Example() {
  return (
    <div className="relative isolate items-center gap-x-6 bg-custom-6 py-5 pb-20 ">
      <p className="px-8 lg:px-64 text-left text-xl leading-10 text-gray-900 hover:text-blue-600 z-10">
        <Link to = "/services" className="inline-block py-4 px-8 w-auto text-lg font-semibold text-gray-600 border-2 border-gray-600 rounded-full transition duration-300 ease-in-out hover:bg-white hover:text-purple-600">
          Explore all our services&nbsp;<span aria-hidden="true">&rarr;</span>
        </Link>
      </p>
    </div>
  )
}
